import React, { useEffect, useMemo, useState } from "react";
import { Check } from "lucide-react";
import { motion } from "framer-motion";
import i18n from "../../i18n";

const CareerSection = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const tr = useMemo(() => {
    void langTick;

    return {
      title: i18n.t("careerSection.title"),
      items: [
        {
          title: i18n.t("careerSection.items.0.title"),
          text: i18n.t("careerSection.items.0.text"),
        },
        {
          title: i18n.t("careerSection.items.1.title"),
          text: i18n.t("careerSection.items.1.text"),
        },
        {
          title: i18n.t("careerSection.items.2.title"),
          text: i18n.t("careerSection.items.2.text"),
        },
      ],
    };
  }, [langTick]);

  return (
    <div className="bg-gradient-to-b from-[#050825] to-[#060A40] text-white py-16 px-8 flex flex-col items-center">
      <h2 className="mt-16 text-4xl font-sb mb-12 text-gray-300">
        {tr.title}
      </h2>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-20 max-w-5xl w-full mb-20">
        {tr.items.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: index * 0.15 }}
            className="flex flex-col items-start text-left transform transition-transform duration-300 hover:scale-105"
          >
            <div className="flex items-center mb-4">
              <Check size={16} className="text-white mr-3" />
              <h3 className="text-lg font-semibold">{item.title}</h3>
            </div>
            <p className="text-gray-400">{item.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CareerSection;




